// components/common/skeletons/PageSkeleton/PageSkeleton.tsx
import "./PageSkeleton.css";

export interface PageSkeletonProps {
  variant?: "small" | "medium" | "large" | "full" | "profile";
  showTextLines?: number;
  className?: string;
}

const PageSkeleton = ({
  variant = "full",
  showTextLines = 4,
  className = "",
}: PageSkeletonProps) => {
  return (
    <div className={`profile-skeleton-wrapper variant-${variant} ${className}`}>
      <div className={`profile-skeleton-inner ${variant === "profile" ? "inner-profile" : ""}`}>
        <div className={`skeleton-avatar ${variant === "profile" ? "avatar-profile" : ""}`} />
        <div className="skeleton-lines">
          {[...Array(showTextLines)].map((_, index) => (
            <div className={`skeleton-line line-${index + 1}`} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageSkeleton;
